import type { AxiosRequestConfig, CancelTokenSource } from 'axios';

/**
 * ## @visiba/http
 *
 * @deprecated Use explicit mock data in tests around TanStack Query request functions instead.
 */
export interface HttpMockPayload<T = unknown> {
	data: T;
	status?: number;
	headers?: Record<string, string> & {
		'set-cookie'?: string[];
	};
}

/**
 * ## @visiba/http
 *
 * @deprecated Configure explicit request functions for TanStack Query hooks and mutations instead.
 */
export interface HttpOptionConfiguration {
	cancelToken?: CancelTokenSource;
	requestConfig?: AxiosRequestConfig;
	mock?: HttpMockPayload;
	throttle?: number;
}

/**
 * ## `@visiba/http`
 *
 * Custom modifications that can be applied to a request. Such as headers or AbortSignals.
 *
 * @deprecated Configure explicit request functions for TanStack Query hooks and mutations instead.
 */
export class HttpOptions {
	public readonly cancelToken: CancelTokenSource | null = null;
	public readonly requestConfig: AxiosRequestConfig;
	public readonly mock: HttpMockPayload | null = null;
	public readonly throttle: number = 0;

	/** Mutable if needed */
	public static defaultRequestConfig: AxiosRequestConfig = {
		headers: {},
	};

	constructor({ requestConfig, cancelToken, mock, throttle }: HttpOptionConfiguration) {
		this.cancelToken = cancelToken ?? null;

		if (requestConfig) {
			this.requestConfig = {
				...requestConfig,
			};
		} else {
			this.requestConfig = {
				...HttpOptions.defaultRequestConfig,
			};
		}

		if (mock) {
			this.mock = mock;
		}

		if (throttle) {
			this.throttle = throttle;
		}

		this.requestConfig.headers = {
			...this.requestConfig.headers,
		};
	}
}
